import { PUBLIC_CARRIER_COOKIE } from 'core/domain/Carrier'
import { cookieClient, type CookieClient } from 'core/infra/cookie'
import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { TenderRepository } from '../infra/TenderRepository'

export type GetTenderFactoryDependencies = {
  tenderRepository: TenderRepository
  cookie: CookieClient
}

export function getTenderFactory({ tenderRepository, cookie }: GetTenderFactoryDependencies) {
  return async function getTenderImpl(id: string, config?: { signal?: AbortSignal }) {
    const tender = await tenderRepository.getTenderById(id, config)

    cookie.setCookie(PUBLIC_CARRIER_COOKIE, tender.carrier)

    return tender
  }
}

export function getTender(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const tenderRepository = new TenderRepository({ httpClient })
  const newGetTender = getTenderFactory({ tenderRepository, cookie: cookieClient })
  return newGetTender(id, config)
}
